// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
  max-width: 1400px;
  margin: 0 auto;
}

.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
  gap: 20px;
}

.date-selector-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.view-mode-selector {
  display: flex;
  gap: 5px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 5px;
}

.view-mode-selector button {
  background: none;
  border: none;
  padding: 8px 15px;
  cursor: pointer;
  border-radius: 3px;
  font-weight: 500;
  transition: all 0.3s;
  color: #666;
}

.view-mode-selector button:hover {
  background: #f5f5f5;
}

.view-mode-selector button.active {
  background: #1976d2;
  color: white;
}

.date-selector {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background: white;
}

.date-selector button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  padding: 0 5px;
}

.date-selector span {
  font-weight: 500;
  min-width: 200px;
  text-align: center;
}

.action-buttons {
  display: flex;
  gap: 10px;
}

.action-buttons-centered {
  justify-content: center;
  flex: 1 1;
  display: flex;
  min-width: 200px;
}

.btn-upload-large {
  padding: 15px 40px !important;
  font-size: 18px !important;
  font-weight: 600 !important;
}

.btn-primary {
  background: #1976d2;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.3s;
}

.btn-primary:hover {
  background: #1565c0;
}

.btn-secondary {
  background: white;
  color: #1976d2;
  border: 1px solid #1976d2;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s;
}

.btn-secondary:hover {
  background: #f5f5f5;
}

.report-section {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.report-section h2 {
  margin-bottom: 10px;
  color: #333;
}

.subtitle {
  color: #666;
  margin-bottom: 20px;
}

.report-table-container {
  overflow-x: auto;
}

.report-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.report-table th {
  background: #f5f5f5;
  padding: 12px;
  text-align: left;
  font-weight: 600;
  border-bottom: 2px solid #ddd;
}

.report-table td {
  padding: 12px;
  border-bottom: 1px solid #eee;
}

.report-table tbody tr:hover {
  background: #f9f9f9;
}

.total-row {
  background: #f0f0f0;
  font-weight: 600;
}

.loading, .no-data {
  text-align: center;
  padding: 40px;
  color: #666;
}

.btn-download-screenshot {
  background: #4caf50;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.3s;
}

.btn-download-screenshot:hover {
  background: #45a049;
}

.btn-download-screenshot:disabled {
  background: #9e9e9e;
  cursor: not-allowed;
  opacity: 0.85;
}

.btn-download-screenshot:disabled:hover {
  background: #9e9e9e;
}

.summary-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.summary-card {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  gap: 15px;
}

.card-icon {
  font-size: 32px;
}

.card-content {
  flex: 1 1;
}

.card-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 5px;
}

.card-value {
  font-size: 24px;
  font-weight: 600;
  color: #333;
}

.btn-edit {
  background: #ff9800;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.3s;
}

.btn-edit:hover {
  background: #f57c00;
}

.btn-delete {
  background: #f44336;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.3s;
}

.btn-delete:hover {
  background: #d32f2f;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
  color: #333;
}

.modal-close {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.3s;
}

.modal-close:hover {
  background: #f5f5f5;
}

.modal-body {
  padding: 20px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 20px;
  border-top: 1px solid #eee;
}

.edit-timesheet-form {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

/* Manual Input Hours modal */
.modal-content.manual-input-modal {
  max-width: 640px;
}

.manual-input-subtitle {
  margin: 6px 0 0 0;
  font-size: 13px;
  color: #666;
  font-weight: normal;
}

.manual-input-body {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.manual-input-section {
  padding: 0;
}

.manual-input-section-title {
  margin: 0 0 12px 0;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #555;
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 8px;
}

.manual-input-row {
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 16px;
  align-items: end;
}

.manual-input-user {
  min-width: 0;
}

.manual-input-hint {
  margin: 0 0 12px 0;
  font-size: 12px;
  color: #666;
  line-height: 1.4;
}

.manual-input-days-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px 20px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #eee;
}

.manual-input-day input {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.manual-input-summary-section {
  padding-top: 8px;
}

.manual-input-total-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  background: #e8f4fd;
  border-radius: 8px;
  border: 1px solid #bbdefb;
  margin-bottom: 16px;
}

.manual-input-total-label {
  font-weight: 600;
  color: #1565c0;
  font-size: 14px;
  margin: 0;
}

.manual-input-total-value {
  font-size: 20px;
  font-weight: 700;
  color: #0d47a1;
  font-variant-numeric: tabular-nums;
}

.manual-input-modal .required {
  color: #c62828;
}

.manual-input-modal .optional {
  font-weight: normal;
  color: #888;
  font-size: 12px;
}

@media (max-width: 560px) {
  .manual-input-row {
    grid-template-columns: 1fr;
  }

  .manual-input-days-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.form-group label {
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.form-group input,
.form-group textarea {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #1976d2;
}

.form-group.total-display {
  grid-column: span 2;
}

.total-value {
  font-size: 20px;
  font-weight: 600;
  color: #1976d2;
  padding: 8px 12px;
  background: #f5f5f5;
  border-radius: 4px;
}

.form-group textarea {
  resize: vertical;
  min-height: 60px;
}

.upload-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.upload-area-small {
  border: 2px dashed #ddd;
  border-radius: 8px;
  padding: 30px;
  text-align: center;
  background: #f9f9f9;
  transition: all 0.3s;
  cursor: pointer;
}

.upload-area-small.drag-active {
  border-color: #1976d2;
  background: #e3f2fd;
}

.upload-icon-small {
  font-size: 48px;
  margin-bottom: 10px;
}

.upload-area-small p {
  margin: 10px 0;
  color: #666;
}

.browse-button-small {
  background: #1976d2;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  margin-top: 10px;
  transition: background 0.3s;
}

.browse-button-small:hover:not(:disabled) {
  background: #1565c0;
}

.browse-button-small:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.upload-note-small {
  font-size: 12px;
  color: #666;
  margin-top: 5px;
}

.uploading-text {
  color: #1976d2;
  font-weight: 500;
  margin-top: 10px;
}

.form-group select {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  width: 100%;
}

.form-group select:focus {
  outline: none;
  border-color: #1976d2;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  align-items: center;
}

/* PTO Section Styles */
.pto-section {
  margin-top: 40px;
  padding-top: 40px;
  border-top: 2px solid #e0e0e0;
}

.pto-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.pto-section h2 {
  margin: 0;
  font-size: 24px;
  color: #333;
}

.pto-balance-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.pto-table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  overflow: hidden;
}

.pto-table-container .report-table {
  margin: 0;
}

.pto-table-container .report-table th,
.pto-table-container .report-table td {
  padding: 12px 15px;
}

/* PTO Type badges */
.role-badge.vacation {
  background: #e3f2fd;
  color: #1976d2;
}

.role-badge.sick {
  background: #ffebee;
  color: #c62828;
}

.role-badge.personal {
  background: #f3e5f5;
  color: #7b1fa2;
}

.role-badge.other {
  background: #fff3e0;
  color: #e65100;
}

/* PTO Status badges */
.status-badge.pending {
  background: #fff3e0;
  color: #e65100;
}

.status-badge.approved {
  background: #e8f5e9;
  color: #2e7d32;
}

.status-badge.rejected {
  background: #ffebee;
  color: #c62828;
}

/* Table cell styling for PTO display */
.report-table td {
  vertical-align: top;
}

.report-table td > div {
  min-height: 20px;
}

/* Submit notification animation */
@keyframes fadeIn {
  from { 
    opacity: 0; 
    transform: translateY(-10px); 
  }
  to { 
    opacity: 1; 
    transform: translateY(0); 
  }
}

.submit-notification {
  animation: fadeIn 0.3s ease-in;
}

/* Upload guide popup */
.upload-with-guide {
  display: flex;
  align-items: center;
  gap: 10px;
}

.guide-icon-wrapper {
  position: relative;
}

.guide-icon-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #1976d2;
  background: white;
  color: #1976d2;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  line-height: 1;
}

.guide-icon-btn:hover {
  background: #1976d2;
  color: white;
}

.guide-popup {
  position: absolute;
  top: 40px;
  right: 0;
  width: 340px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 100;
  animation: fadeIn 0.2s ease-in;
  border: 1px solid #e0e0e0;
}

.guide-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
  font-weight: 600;
  color: #333;
  font-size: 15px;
}

.guide-close-btn {
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  color: #999;
  padding: 0;
  line-height: 1;
}

.guide-close-btn:hover {
  color: #333;
}

.guide-steps {
  margin: 0;
  padding: 16px 16px 16px 32px;
  list-style: none;
  counter-reset: guide-step;
}

.guide-steps li {
  counter-increment: guide-step;
  padding: 8px 0;
  font-size: 14px;
  color: #444;
  line-height: 1.5;
  position: relative;
}

.guide-steps li::before {
  content: "Step " counter(guide-step) ": ";
  font-weight: 600;
  color: #1976d2;
}

.guide-steps li:not(:last-child) {
  border-bottom: 1px solid #f0f0f0;
}

.guide-contact {
  margin: 0;
  padding: 12px 16px;
  font-size: 13px;
  color: #666;
  border-top: 1px solid #eee;
  line-height: 1.5;
}

.guide-contact a {
  color: #1976d2;
  text-decoration: none;
  font-weight: 500;
}

.guide-contact a:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".dashboard {\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.dashboard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.date-selector-container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.view-mode-selector {\n  display: flex;\n  gap: 5px;\n  background: white;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  padding: 5px;\n}\n\n.view-mode-selector button {\n  background: none;\n  border: none;\n  padding: 8px 15px;\n  cursor: pointer;\n  border-radius: 3px;\n  font-weight: 500;\n  transition: all 0.3s;\n  color: #666;\n}\n\n.view-mode-selector button:hover {\n  background: #f5f5f5;\n}\n\n.view-mode-selector button.active {\n  background: #1976d2;\n  color: white;\n}\n\n.date-selector {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 15px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  background: white;\n}\n\n.date-selector button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n  padding: 0 5px;\n}\n\n.date-selector span {\n  font-weight: 500;\n  min-width: 200px;\n  text-align: center;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 10px;\n}\n\n.action-buttons-centered {\n  justify-content: center;\n  flex: 1;\n  display: flex;\n  min-width: 200px;\n}\n\n.btn-upload-large {\n  padding: 15px 40px !important;\n  font-size: 18px !important;\n  font-weight: 600 !important;\n}\n\n.btn-primary {\n  background: #1976d2;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background 0.3s;\n}\n\n.btn-primary:hover {\n  background: #1565c0;\n}\n\n.btn-secondary {\n  background: white;\n  color: #1976d2;\n  border: 1px solid #1976d2;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.3s;\n}\n\n.btn-secondary:hover {\n  background: #f5f5f5;\n}\n\n.report-section {\n  background: white;\n  padding: 30px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.report-section h2 {\n  margin-bottom: 10px;\n  color: #333;\n}\n\n.subtitle {\n  color: #666;\n  margin-bottom: 20px;\n}\n\n.report-table-container {\n  overflow-x: auto;\n}\n\n.report-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n\n.report-table th {\n  background: #f5f5f5;\n  padding: 12px;\n  text-align: left;\n  font-weight: 600;\n  border-bottom: 2px solid #ddd;\n}\n\n.report-table td {\n  padding: 12px;\n  border-bottom: 1px solid #eee;\n}\n\n.report-table tbody tr:hover {\n  background: #f9f9f9;\n}\n\n.total-row {\n  background: #f0f0f0;\n  font-weight: 600;\n}\n\n.loading, .no-data {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n.btn-download-screenshot {\n  background: #4caf50;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background 0.3s;\n}\n\n.btn-download-screenshot:hover {\n  background: #45a049;\n}\n\n.btn-download-screenshot:disabled {\n  background: #9e9e9e;\n  cursor: not-allowed;\n  opacity: 0.85;\n}\n\n.btn-download-screenshot:disabled:hover {\n  background: #9e9e9e;\n}\n\n.summary-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.summary-card {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.card-icon {\n  font-size: 32px;\n}\n\n.card-content {\n  flex: 1;\n}\n\n.card-label {\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 5px;\n}\n\n.card-value {\n  font-size: 24px;\n  font-weight: 600;\n  color: #333;\n}\n\n.btn-edit {\n  background: #ff9800;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background 0.3s;\n}\n\n.btn-edit:hover {\n  background: #f57c00;\n}\n\n.btn-delete {\n  background: #f44336;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background 0.3s;\n}\n\n.btn-delete:hover {\n  background: #d32f2f;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #eee;\n}\n\n.modal-header h3 {\n  margin: 0;\n  color: #333;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 28px;\n  cursor: pointer;\n  color: #666;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background 0.3s;\n}\n\n.modal-close:hover {\n  background: #f5f5f5;\n}\n\n.modal-body {\n  padding: 20px;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 20px;\n  border-top: 1px solid #eee;\n}\n\n.edit-timesheet-form {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 15px;\n}\n\n/* Manual Input Hours modal */\n.modal-content.manual-input-modal {\n  max-width: 640px;\n}\n\n.manual-input-subtitle {\n  margin: 6px 0 0 0;\n  font-size: 13px;\n  color: #666;\n  font-weight: normal;\n}\n\n.manual-input-body {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.manual-input-section {\n  padding: 0;\n}\n\n.manual-input-section-title {\n  margin: 0 0 12px 0;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #555;\n  border-bottom: 1px solid #e8e8e8;\n  padding-bottom: 8px;\n}\n\n.manual-input-row {\n  display: grid;\n  grid-template-columns: 1fr auto auto;\n  gap: 16px;\n  align-items: end;\n}\n\n.manual-input-user {\n  min-width: 0;\n}\n\n.manual-input-hint {\n  margin: 0 0 12px 0;\n  font-size: 12px;\n  color: #666;\n  line-height: 1.4;\n}\n\n.manual-input-days-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px 20px;\n  padding: 16px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #eee;\n}\n\n.manual-input-day input {\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n\n.manual-input-summary-section {\n  padding-top: 8px;\n}\n\n.manual-input-total-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 14px 16px;\n  background: #e8f4fd;\n  border-radius: 8px;\n  border: 1px solid #bbdefb;\n  margin-bottom: 16px;\n}\n\n.manual-input-total-label {\n  font-weight: 600;\n  color: #1565c0;\n  font-size: 14px;\n  margin: 0;\n}\n\n.manual-input-total-value {\n  font-size: 20px;\n  font-weight: 700;\n  color: #0d47a1;\n  font-variant-numeric: tabular-nums;\n}\n\n.manual-input-modal .required {\n  color: #c62828;\n}\n\n.manual-input-modal .optional {\n  font-weight: normal;\n  color: #888;\n  font-size: 12px;\n}\n\n@media (max-width: 560px) {\n  .manual-input-row {\n    grid-template-columns: 1fr;\n  }\n\n  .manual-input-days-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.form-group label {\n  font-weight: 500;\n  color: #333;\n  font-size: 14px;\n}\n\n.form-group input,\n.form-group textarea {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  font-family: inherit;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #1976d2;\n}\n\n.form-group.total-display {\n  grid-column: span 2;\n}\n\n.total-value {\n  font-size: 20px;\n  font-weight: 600;\n  color: #1976d2;\n  padding: 8px 12px;\n  background: #f5f5f5;\n  border-radius: 4px;\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 60px;\n}\n\n.upload-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.upload-area-small {\n  border: 2px dashed #ddd;\n  border-radius: 8px;\n  padding: 30px;\n  text-align: center;\n  background: #f9f9f9;\n  transition: all 0.3s;\n  cursor: pointer;\n}\n\n.upload-area-small.drag-active {\n  border-color: #1976d2;\n  background: #e3f2fd;\n}\n\n.upload-icon-small {\n  font-size: 48px;\n  margin-bottom: 10px;\n}\n\n.upload-area-small p {\n  margin: 10px 0;\n  color: #666;\n}\n\n.browse-button-small {\n  background: #1976d2;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  margin-top: 10px;\n  transition: background 0.3s;\n}\n\n.browse-button-small:hover:not(:disabled) {\n  background: #1565c0;\n}\n\n.browse-button-small:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.upload-note-small {\n  font-size: 12px;\n  color: #666;\n  margin-top: 5px;\n}\n\n.uploading-text {\n  color: #1976d2;\n  font-weight: 500;\n  margin-top: 10px;\n}\n\n.form-group select {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  font-family: inherit;\n  width: 100%;\n}\n\n.form-group select:focus {\n  outline: none;\n  border-color: #1976d2;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  align-items: center;\n}\n\n/* PTO Section Styles */\n.pto-section {\n  margin-top: 40px;\n  padding-top: 40px;\n  border-top: 2px solid #e0e0e0;\n}\n\n.pto-section .section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 25px;\n}\n\n.pto-section h2 {\n  margin: 0;\n  font-size: 24px;\n  color: #333;\n}\n\n.pto-balance-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.pto-table-container {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  overflow: hidden;\n}\n\n.pto-table-container .report-table {\n  margin: 0;\n}\n\n.pto-table-container .report-table th,\n.pto-table-container .report-table td {\n  padding: 12px 15px;\n}\n\n/* PTO Type badges */\n.role-badge.vacation {\n  background: #e3f2fd;\n  color: #1976d2;\n}\n\n.role-badge.sick {\n  background: #ffebee;\n  color: #c62828;\n}\n\n.role-badge.personal {\n  background: #f3e5f5;\n  color: #7b1fa2;\n}\n\n.role-badge.other {\n  background: #fff3e0;\n  color: #e65100;\n}\n\n/* PTO Status badges */\n.status-badge.pending {\n  background: #fff3e0;\n  color: #e65100;\n}\n\n.status-badge.approved {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.status-badge.rejected {\n  background: #ffebee;\n  color: #c62828;\n}\n\n/* Table cell styling for PTO display */\n.report-table td {\n  vertical-align: top;\n}\n\n.report-table td > div {\n  min-height: 20px;\n}\n\n/* Submit notification animation */\n@keyframes fadeIn {\n  from { \n    opacity: 0; \n    transform: translateY(-10px); \n  }\n  to { \n    opacity: 1; \n    transform: translateY(0); \n  }\n}\n\n.submit-notification {\n  animation: fadeIn 0.3s ease-in;\n}\n\n/* Upload guide popup */\n.upload-with-guide {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.guide-icon-wrapper {\n  position: relative;\n}\n\n.guide-icon-btn {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: 2px solid #1976d2;\n  background: white;\n  color: #1976d2;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n  line-height: 1;\n}\n\n.guide-icon-btn:hover {\n  background: #1976d2;\n  color: white;\n}\n\n.guide-popup {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  width: 340px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  z-index: 100;\n  animation: fadeIn 0.2s ease-in;\n  border: 1px solid #e0e0e0;\n}\n\n.guide-popup-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  border-bottom: 1px solid #eee;\n  font-weight: 600;\n  color: #333;\n  font-size: 15px;\n}\n\n.guide-close-btn {\n  background: none;\n  border: none;\n  font-size: 16px;\n  cursor: pointer;\n  color: #999;\n  padding: 0;\n  line-height: 1;\n}\n\n.guide-close-btn:hover {\n  color: #333;\n}\n\n.guide-steps {\n  margin: 0;\n  padding: 16px 16px 16px 32px;\n  list-style: none;\n  counter-reset: guide-step;\n}\n\n.guide-steps li {\n  counter-increment: guide-step;\n  padding: 8px 0;\n  font-size: 14px;\n  color: #444;\n  line-height: 1.5;\n  position: relative;\n}\n\n.guide-steps li::before {\n  content: \"Step \" counter(guide-step) \": \";\n  font-weight: 600;\n  color: #1976d2;\n}\n\n.guide-steps li:not(:last-child) {\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.guide-contact {\n  margin: 0;\n  padding: 12px 16px;\n  font-size: 13px;\n  color: #666;\n  border-top: 1px solid #eee;\n  line-height: 1.5;\n}\n\n.guide-contact a {\n  color: #1976d2;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.guide-contact a:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
